import { Button, Drawer } from "antd";
import ListPermissionAddToMenu from "./ListPermissionAddToMenu";
import { neutral, spacing } from "../../../../theme/tokens";

const ModalAddPermissionInMenu = (props) => {
  const {
    isOpen,
    onCancel,
    handleRemovePermission,
    handleSelectPermission,
    existedListingPermission,
  } = props;

  return (
    <>
      <Drawer
        title="Thêm quyền cho menu"
        placement="right"
        width="min(880px, 100vw)"
        open={isOpen}
        onClose={onCancel}
        destroyOnClose
        styles={{ body: { background: neutral[50], padding: spacing[6] } }}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: spacing[2] }}>
            <Button onClick={onCancel}>Đóng</Button>
          </div>
        }
      >
        <ListPermissionAddToMenu
          onRemovePermission={(Ids) => handleRemovePermission(Ids[0])}
          onSelectPermission={(permission) =>
            handleSelectPermission(permission)
          }
          existedListPermission={existedListingPermission}
        />
      </Drawer>
    </>
  );
};
export default ModalAddPermissionInMenu;
